import React from 'react'
import icon from '../icon.ico'
import {AiFillLinkedin} from "react-icons/ai"
import {AiOutlineGithub, AiOutlineMail} from 'react-icons/ai'

const Footer = () => {
  return (
    <div className='pt-[50px] md:flex justify-between'>
       <div>
        <div className='flex gap-3 items-center'>
            <img src={icon} className='w-[100px] h-[100px]'/>
            <h1 className='text-primary text-xl'>Sourabh Rathore</h1>
            <div className='bg-primary text-primary items-center align-middle w-[1px] h-[40px]'></div>
            <h1 className='text-white text-xs'>© 2022 SR Portfolia —@SOURABH_SINGH2</h1>
        </div>
       </div>
       <div className='items-center flex justify-center gap-5 px-12'>
        <a href='https://www.linkedin.com/in/sourabh-singh-7b001922a'>
        <div className='bg-blue-500 hover:animate-bounce w-[60px] h-[60px] flex justify-center items-center align-middle  rounded-full '>
        <AiFillLinkedin className='w-12 h-12 items-center align-middle rounded-full text-white'/>
        </div>
        </a>
        <a href='https://github.com/Sourabh20022002'>
        <div className='bg-black w-[60px] hover:animate-bounce h-[60px] flex justify-center items-center align-middle  rounded-full '>
        <AiOutlineGithub className='w-12 h-12 items-center align-middle rounded-full text-white'/>
        </div>
        </a>
        <a href='mailto:sourabh52.singh@gmail.com'>
        <div className='bg-green-500 w-[60px] hover:animate-bounce h-[60px] flex justify-center items-center align-middle  rounded-full '>
        <AiOutlineMail className='w-12 h-12 items-center align-middle rounded-full text-white'/>
        </div>
        </a>
       </div>
    </div>
  )
}

export default Footer